import React, { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import NavBar from "./components/NavBar.jsx";
import PersonalBrandHero from "./components/PersonalBrandHero.jsx";
import MarqueeRibbon from "./components/MarqueeRibbon.jsx";
import AuthorityPillars from "./components/AuthorityPillars.jsx";
import Solutions from "./components/Solutions.jsx";
import PortfolioSites from "./components/PortfolioSites.jsx";
import ConversionWidgets from "./components/ConversionWidgets.jsx";
import Roadmap from "./components/Roadmap.jsx";
import CaseStudies from "./components/CaseStudies.jsx";
import FaqSection from "./components/FaqSection.jsx";
import PricingFooter from "./components/PricingFooter.jsx";
import LeadForm from "./components/LeadForm.jsx";
import { CustomCursor } from "./components/CustomCursor.jsx";
import { useLenis } from "./hooks/useLenis.js";
import { runAllFX } from "./lib/animeFx.js";
import { ThemeLangProvider, useLang } from "./i18n.jsx";

function WhatsAppFloat() {
  const { waLink } = useLang();
  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-5 right-5 z-50 grid place-items-center w-14 h-14 rounded-full bg-acid text-ink shadow-2xl shadow-black/40 hover:scale-105 active:scale-95 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-acid/30 animate-ping" />
      <span className="relative">
        <MessageCircle className="w-6 h-6" />
      </span>
    </a>
  );
}

function Shell() {
  const [cursor, setCursor] = useState({ x: -100, y: -100, hover: false });

  useEffect(() => {
    const t = setTimeout(runAllFX, 120);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const move = (e) =>
      setCursor({
        x: e.clientX,
        y: e.clientY,
        hover: !!e.target.closest("[data-cursor]"),
        text: e.target.closest("[data-cursor-text]")?.dataset.cursorText || "",
      });
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <>
      <CustomCursor pos={cursor} />
      <WhatsAppFloat />
      <NavBar />
      <PersonalBrandHero />
      <MarqueeRibbon />
      <AuthorityPillars />
      <Solutions />
      <PortfolioSites />
      <ConversionWidgets />
      <CaseStudies />
      <Roadmap />
      <LeadForm />
      <PricingFooter />
      <FaqSection />
    </>
  );
}

export default function App() {
  useLenis();
  return (
    <ThemeLangProvider>
      <main className="overflow-x-clip">
        <Shell />
      </main>
    </ThemeLangProvider>
  );
}
